import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "title"]

  connect() {
    this.detailsUrl = this.detailsTarget.href
    this.syncDetails()
  }

  submit(event) {
    if (event.isComposing) return

    event.preventDefault()
    if (!event.currentTarget.value.trim()) return

    this.element.requestSubmit()
  }

  syncDetails() {
    const url = new URL(this.detailsUrl)
    const title = this.titleTarget.value.trim()

    if (title) {
      url.searchParams.set("task[title]", title)
    } else {
      url.searchParams.delete("task[title]")
    }

    this.detailsTarget.href = url.toString()
  }
}
